<template>
  <CModal :show.sync="show" centered title="Upload media" size="xl">
    <Uploader :gallery="gallery_id" modal ref="uploader"/>
    <template #footer>
     <div class="d-none"></div>
    </template>
  </CModal>
</template>

<script>
import Uploader from "@/domain/uploader/Uploader.vue";
import {mapGetters} from "vuex";

export default {
  name: "UploaderModal",
  components: {Uploader},
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters('photoSearch', [
      'gallery_id'
    ]),
  },
  emits: ['uploaded'],
  methods: {
    async open() {
      this.$refs.uploader.openUploadForm(() => {
        this.show = true
      })
    },
    newFileDropped(files) {
      this.$refs.uploader.newFileDropped(files)
      this.show = true
    }
  }
}
</script>

<style scoped>

</style>